import { useMemo } from 'react'

import { calculateSizeInLots } from '@pages/Trade/utils/helpers'

import type { DxtradeInstrumentMap } from './useDxtradeInstruments'
import type { PortfolioTrade } from './useDxtradePortfolioTrades'

export const useOpenTradesWithLots = (
  trades: PortfolioTrade[] | undefined,
  instruments: DxtradeInstrumentMap,
  symbol?: string
): PortfolioTrade[] => {
  return useMemo(() => {
    if (!trades?.length) {
      return trades ?? []
    }

    const sourceTrades = symbol ? trades.filter((trade) => trade.symbol === symbol) : trades

    return sourceTrades.map((trade) => {
      if (!trade.symbol) {
        return trade
      }

      const instrument = instruments[trade.symbol]
      const lotSize = instrument?.lotSize
      const quantityIncrement = instrument?.quantityIncrement
      const instrumentCurrency = instrument?.currency ?? null
      const priceIncrement = instrument?.priceIncrement ?? null

      if (!lotSize) {
        return { ...trade, instrumentCurrency, priceIncrement }
      }

      const sizeLots = calculateSizeInLots(trade.quantity, lotSize, quantityIncrement)

      return {
        ...trade,
        lotSize,
        sizeLots,
        description: instrument?.description ?? undefined,
        instrumentCurrency,
        priceIncrement,
      }
    })
  }, [trades, instruments, symbol])
}
